function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.253058 0.655101C0.355692 0.571243 0.480377 0.518841 0.612101 0.504205C0.743826 0.489569 0.876973 0.513322 0.995511 0.572605L21.6192 10.8846C21.7336 10.9416 21.8298 11.0294 21.8971 11.1381C21.9644 11.2468 22 11.3721 22 11.4999C22 11.6277 21.9644 11.753 21.8971 11.8617C21.8298 11.9704 21.7336 12.0582 21.6192 12.1152L0.995511 22.4272C0.877092 22.4865 0.744063 22.5104 0.612418 22.4959C0.480773 22.4814 0.356116 22.4292 0.253439 22.3455C0.150761 22.2619 0.0744323 22.1503 0.0336315 22.0243C-0.00716939 21.8983 -0.0107059 21.7632 0.0234476 21.6352L2.72653 11.5006L0.0234476 1.36594C-0.0108701 1.23793 -0.00745505 1.10273 0.0332817 0.976614C0.0740185 0.850498 0.15034 0.738847 0.253058 0.655101ZM3.96532 12.1881L1.74621 20.5147L19.7741 11.5006L1.74484 2.48652L3.96532 10.8131H13.0617C13.2441 10.8131 13.4189 10.8856 13.5478 11.0145C13.6768 11.1434 13.7492 11.3183 13.7492 11.5006C13.7492 11.6829 13.6768 11.8578 13.5478 11.9867C13.4189 12.1156 13.2441 12.1881 13.0617 12.1881H3.96532Z",
  fill: "white"
});
function SvgArrowLeftOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftOutline);
export default __webpack_public_path__ + "static/media/arrow_left_outline.f04cd9034bb63e923ea8f4127efbb846.svg";
export { ForwardRef as ReactComponent };